// Explore-stats page: Parliamentarians who changed electorate.
// Recreates the Handbook page — a Gantt timeline of every parliamentarian
// who represented more than one electorate, with a supporting table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import GanttTimeline from './GanttTimeline';

export default function ChangedElectorate() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('changed-electorate');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Parliamentarians who changed electorate"
      description={`Parliamentarians who represented more than one electorate${
        charts.total ? ` (${charts.total})` : ''
      } — through electorates being created, renamed or abolished, or by moving seats.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="changed-electorate"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Parliamentarians who changed electorate
          </Typography>
          <GanttTimeline items={charts.timeline || []} />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
